import axios from "axios";
import { httpClient, ApiClient } from "@/lib/http-client";

import { getAuthToken } from "@dynamic-labs/sdk-react-core";
import { axiosRequestConfig } from "@/../config/swr.config";

export * from "@/lib/http-client";
export const privateApiV2 = new ApiClient(httpClient, () => ({ "SF-JWT": getAuthToken() }));
export const apiUtils = new ApiClient(axios.create(axiosRequestConfig.utils));
